import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Response } from '../../../../_shared/models';
import { PaginatedResult } from '../../../../_shared/models/paginated-result.model';
import { PartsUsageFilterRequest, PartsUsageItem } from '../models/parts-usage.model';

@Injectable({
  providedIn: 'root'
})
export class PartsUsageService {
  private http = inject(HttpClient);

  getPartsUsageAsync(request: PartsUsageFilterRequest, cancellation: Subject<void>): Promise<Response<PaginatedResult<PartsUsageItem>>> {
    return firstValueFrom(
      this.http.post<Response<PaginatedResult<PartsUsageItem>>>(
        `${environment.apiEndpoint}/parts/parts-usage/filter`,
        request
      ).pipe(takeUntil(cancellation))
    );
  }
}